module.exports = __webpack_public_path__ + "media/sora_aspect_ratio.64507dc0.mp4";